import React from 'react';
import styled from 'styled-components';

import FadeIn from 'react-fade-in';
import SubNavBar from './components/subNav';
import { Redirect, Route, Switch } from 'react-router';
import CustomerPage from './components/customerPage';
import { CustomersTable } from './components/customersTable';
import { DocumentsTable } from './components/documentsTable';

const BackgroundContainer = styled.div`
  flex: 1;
`;

const Container = styled.div`
  display: flex;
  flex: 1;
  margin: 1rem;
`;

function MollyWL() {
  return (
    <BackgroundContainer>
      <SubNavBar />
      <Container>
        <Switch>
          <Route exact path="/mollywl/customers">
            <FadeIn>
              <CustomersTable />
            </FadeIn>
          </Route>
          <Route path="/mollywl/customers/:username">
            <CustomerPage />
          </Route>
          <Route path="/mollywl/documents">
            <FadeIn>
              <DocumentsTable />
            </FadeIn>
          </Route>
          <Route render={() => <Redirect to="/mollywl/customers" />} />
        </Switch>
      </Container>
    </BackgroundContainer>
  );
}

export default MollyWL;
